/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { DesignCategories } from "App/IOC/Services";

export default {
    List: DesignCategories.List,
    Create: DesignCategories.Create,
    Update: DesignCategories.Update,
    Reorder: DesignCategories.Reorder,
    Delete: DesignCategories.Delete
};
